export default __webpack_public_path__ + "static/media/shape2.a447b195.svg";